export default class Language {
    constructor() {

    }

    preValidateFormFields(id) {
        let translation = '';

        switch (id) {
            case 'gender':
            case 'geslacht':
            case 'state':
                translation = '%s belum dipilih';
                break;

            case 'firstname':
            case 'lastname':
            case 'voorletter':
            case 'achternaam':
                translation = '%s harus diisi';
                break;

            case 'street':
            case 'housenumber':
            case 'city':
            case 'address':
            case 'straat':
            case 'huisnummer':
            case 'plaats':
                translation = '%s wajib diisi';
                break;

            case 'telephone':
            case 'email':
            case 'heeltelefoonnummer':
            case 'mobile':
            case 'zipcode':
            case 'birthdate':
            case 'bankaccount':
                translation = 'Pengisian %s salah';
                break;

            case 'opt-in':
                translation = 'Centang kotak untuk melanjutkan';
                break;

            default:
                translation = 'Pengisian kolom ini salah';
                break;
        }

        return translation;
    }
}
